<template>
  <div class="as" :class="'as--' + state.kind" data-test="pfe-switch-card">
    <div class="as-line">
      <span class="as-icon"><i class="fa fa-paper-plane" aria-hidden="true"></i></span>
      <span id="pfe-switch-label" class="as-title">Auto-send post-op instructions</span>
      <button
        type="button"
        class="as-switch"
        :class="{ 'as-switch--on': state.checked }"
        role="switch"
        :aria-checked="state.checked ? 'true' : 'false'"
        aria-labelledby="pfe-switch-label"
        :disabled="!state.canToggle || busy"
        data-test="pfe-switch"
        @click="$emit('toggle')"
      ><span class="as-knob"></span></button>
    </div>
    <div class="as-msg" :class="{ 'as-msg--blocked': state.kind === 'blocked' }" data-test="pfe-switch-message">
      <i v-if="state.kind === 'blocked'" class="fa fa-lock" aria-hidden="true"></i>
      <span>{{ state.message }}</span>
    </div>
    <div v-if="error" class="as-error" role="alert" data-test="pfe-switch-error">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>{{ error }}
    </div>
  </div>
</template>

<script>
/**
 * The master switch card (design: Off / On since … / Blocked — one reason at a time). Presentational: the editor decides the
 * state (utils/postOp/readiness.js switchState) and shows the SERVER's `liveSince`, never one computed here.
 */
export default {
  name: 'PfeAutoSendSwitch',
  props: {
    state: { type: Object, required: true },
    busy: { type: Boolean, default: false },
    /** The server's own reason when a switch-on was refused (409 ENABLE_BLOCKED) or failed. */
    error: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import './editor';

.as {
  flex: 0 1 400px;
  min-width: 300px;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1.5px solid $pp-border;
  background: $pfe-neutral-25;
  display: flex;
  flex-direction: column;
  gap: 6px;

  &--on { border-color: $pp-brand; background: $pp-brand-subtle; }
}
.as-line { display: flex; align-items: center; gap: 10px; }
.as-icon { display: flex; color: $pfe-neutral-400; .as--on & { color: $pp-brand; } }
.as-title { flex: 1; font-size: 15px; font-weight: 800; color: $pp-text; }

.as-switch {
  position: relative;
  flex: none;
  width: 44px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: $pp-border-strong;
  cursor: pointer;
  transition: background 0.15s ease;

  &--on { background: $pp-brand; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
  &:focus-visible { outline: 2px solid $pp-brand; outline-offset: 2px; }
}
.as-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(12, 15, 14, 0.25);
  transition: transform 0.15s ease;

  .as-switch--on & { transform: translateX(20px); }
}

.as-msg {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding-left: 26px;
  font-size: 13px;
  line-height: 1.45;
  color: $pfe-neutral-600;

  .as--on & { color: $pp-brand-deep; }
  i { margin-top: 3px; color: $pfe-neutral-500; }
}
.as-error {
  padding-left: 26px;
  font-size: 13px;
  font-weight: 600;
  color: $pfe-red-ink;

  i { margin-right: 6px; }
}
</style>
